/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { GET_TASK, TASK_RESPONSE } = constants.GetTaskConstants;

export default {
    GET_TASK,
    TASK_RESPONSE,

  requestTaskData: payload => ({
    type: GET_TASK,
    payload
  }),
  taskDataReceived: () => ({
    type: TASK_RESPONSE
  }),
};
